import React from "react";
import { Typography } from "@material-ui/core";

export function EmptyViewFieldPlaceholder() {
  return React.createElement(
    Typography,
    { component: "span", color: "textSecondary" },
    "-"
  );
}